const init = {
  isLogin: false,
  token: localStorage.getItem("token") || null,
  user: {}
};

const user = (state = init, action) => {
  switch (action.type) {
    case "SET_USER":
      const loginstate = action.user;
      loginstate.isLogin = true;
      localStorage.setItem("token", loginstate.token);
      return loginstate;
    case "LOGOUT_USER":
      localStorage.removeItem("token");
      return init;
    default:
      return state;
  }
};

export default user;
